import { BookingTypeValues } from '@components/BookingType';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// Define a type for the slice state
export interface AppState {
  language: string;
  currency: string;
  cartId: string | null;
  bookingType: BookingTypeValues | null;
  orderRoomingListPassword: string | null;
}

// Define the initial state using that type
export const appInitialState: AppState = {
  language: 'auto',
  currency: 'USD',
  cartId: null,
  bookingType: null,
  orderRoomingListPassword: null,
};

export const AppSlice = createSlice({
  name: 'app',
  initialState: appInitialState,
  reducers: {
    setAppLanguage: (state, action: PayloadAction<AppState['language']>) => {
      state.language = action.payload;
    },
    setAppCurrency: (state, action: PayloadAction<AppState['currency']>) => {
      state.currency = action.payload;
    },
    setCartId: (state, action: PayloadAction<AppState['cartId']>) => {
      state.cartId = action.payload;
    },
    setBookingType: (state, action: PayloadAction<AppState['bookingType']>) => {
      state.bookingType = action.payload;
    },
    setOrderRoomingListPassword: (
      state,
      action: PayloadAction<AppState['orderRoomingListPassword']>
    ) => {
      state.orderRoomingListPassword = action.payload;
    },
  },
});

export const {
  setAppLanguage,
  setAppCurrency,
  setCartId,
  setBookingType,
  setOrderRoomingListPassword,
} = AppSlice.actions;

export default AppSlice;
